module.exports = __webpack_public_path__ + "static/media/ico-indoor-small.6177ccb2.svg";